const comments = [
  {
    name: '追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20portrait%20avatar%20style%2C%20soft%20golden%20lighting%2C%20abstract%20geometric%20background%20with%20amber%20tones%2C%20modern%20minimal%20illustration%2C%20friendly%20vibe&width=96&height=96&seq=avatar-01&orientation=squarish',
    text: '用了蚂蚁影视快一年了，资源更新真的快！院线下映不到一个月就能看高清版，而且播放完全不卡，比别的平台强太多了。',
    date: '3天前',
    likes: 256,
  },
  {
    name: '电影控小林',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20avatar%20portrait%2C%20soft%20coral%20and%20gold%20lighting%2C%20modern%20minimal%20design%2C%20cinematic%20mood%2C%20friendly%20atmosphere&width=96&height=96&seq=avatar-02&orientation=squarish',
    text: '画质真的绝了！用蚂蚁影视APP投屏到电视上看4K大片，效果不比影院差。而且还不用注册，打开就能看，太方便了。',
    date: '5天前',
    likes: 189,
  },
  {
    name: '夏日追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20avatar%20illustration%20with%20soft%20golden%20glow%2C%20abstract%20shapes%20background%2C%20minimal%20modern%20style%2C%20cozy%20amber%20tones&width=96&height=96&seq=avatar-03&orientation=squarish',
    text: '我妈也在用蚂蚁影视追剧了！操作简单，老人家一学就会。片库是真的全，从老剧到新片应有尽有，全家都爱看。',
    date: '1周前',
    likes: 312,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            用户评价
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            来自蚂蚁影视用户的真实反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-300/30 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover border-2 border-primary-500/30 flex-shrink-0"
                  width="40"
                  height="40"
                  loading="lazy"
                />
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-100 truncate">
                    {comment.name}
                  </h3>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed flex-1">
                {comment.text}
              </p>
              <div className="mt-4 pt-3 border-t border-background-300/20 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}